import { FlightCabinClassInfo, FlightsCabinClass } from '__generated__/api/types';

export const cabinClassConverter = (cabinClass: FlightCabinClassInfo): FlightsCabinClass => {
  return FlightsCabinClass[FlightCabinClassInfo[cabinClass] as keyof typeof FlightsCabinClass];
};
